module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/a0121-mcompany/mcompany.component.css
// module id = ./src/app/a0121-mcompany/mcompany.component.css
// module chunks = main